import { VyStack } from '@vy/ui-design-system';
import { isRevShareProductVariant, isTiersVolumeProductVariant } from '@vy/services';
import { useFormContext } from 'react-hook-form';
import { useChargeContext } from '../../charge-context';
import type { PlanInputForm } from '../../CreatePlanForm/create-plan-form-types/plan-input-form';
import { BillingMeteringSection, ProductSettingsSection, SchedulingSection, UpgradeOptionsSection } from '../sections';

export function TiersVariant() {
  const { itemIndex: productIndex } = useChargeContext();
  const { watch } = useFormContext<PlanInputForm>();

  const usageVariants = watch(`usageProducts.${productIndex}.variants`) ?? [];

  const isRevShare = usageVariants.every((usageVariant) => isRevShareProductVariant(usageVariant));
  const isVolume = usageVariants.some((usageVariant) => isTiersVolumeProductVariant(usageVariant));

  return (
    <VyStack sx={{ gap: 2.5 }}>
      <ProductSettingsSection />
      <SchedulingSection />
      <BillingMeteringSection
        showFlatRateSwitch={!isRevShare}
        showBulkSwitch={!isRevShare}
        showAutomaticUpgrade={isVolume}
        isRevShare={isRevShare}
      />
      <UpgradeOptionsSection />
    </VyStack>
  );
}
